import { useMemo } from 'react';

/**
 * Thin wrapper around `navigator.vibrate` so the rest of the app can fire
 * "haptic-like" feedback on key interactions (Welcome CTA, mode select,
 * Complete Session) without guarding for browser support at every call site.
 * Silently no-ops where the API is unavailable.
 *
 * The returned object is memoized so its identity is stable across renders —
 * consumers can safely list it in effect dependency arrays without triggering
 * spurious re-runs.
 */
export function useHaptic() {
  return useMemo(() => {
    const fire = (pattern: number | number[]) => {
      if (typeof navigator === 'undefined') return;
      if (typeof navigator.vibrate !== 'function') return;
      try {
        navigator.vibrate(pattern);
      } catch {
        /* ignore */
      }
    };

    return {
      tap: () => fire(10),
      pulse: () => fire([12, 40, 12]),
      success: () => fire([20, 60, 20, 60, 40]),
    };
  }, []);
}
